import React from "react";
import styled from "styled-components";
import { FaExternalLinkAlt, FaTimes, FaSearchPlus } from "react-icons/fa";

export default function ModalRecibo({ url, onClose }) {
  if (!url) return null;

  const isPdf = url.toLowerCase().includes(".pdf") || url.toLowerCase().includes("application/pdf");

  const handleOpenFull = () => {
    window.open(url, "_blank");
  };

  return (
    <Overlay onClick={onClose}>
      <Container onClick={(e) => e.stopPropagation()}>
        <Header>
          <Title>
            <FaSearchPlus /> Recibo de Depósito
          </Title>
          <ButtonGroup>
            <ActionButton onClick={handleOpenFull} title="Abrir em nova aba">
              <FaExternalLinkAlt /> Abrir Original
            </ActionButton>
            <CloseButton onClick={onClose}>
              <FaTimes />
            </CloseButton>
          </ButtonGroup>
        </Header>

        <ImageBody>
          {isPdf ? (
            <PdfFrame src={url} title="Recibo PDF" />
          ) : (
            <ScrollArea>
              <ReceiptImage src={url} alt="Recibo" />
            </ScrollArea>
          )}
        </ImageBody>

        <Footer>
          <small>{isPdf ? "Visualizando PDF." : "Dica: Use o scroll para ver o recibo completo."}</small>
        </Footer>
      </Container>
    </Overlay>
  );
}

// --- ESTILIZAÇÃO ---

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10005;
  backdrop-filter: blur(5px);
`;

const Container = styled.div`
  background: #1a1a1a;
  width: 90%;
  max-width: 800px;
  height: 85vh;
  border-radius: 12px;
  border: 1px solid #d4af37;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.5);
`;

const Header = styled.div`
  padding: 15px 20px;
  background: #000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #333;
`;

const Title = styled.h3`
  color: #d4af37;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.1rem;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
`;

const ActionButton = styled.button`
  background: #d4af37;
  color: #000;
  border: none;
  padding: 8px 15px;
  border-radius: 6px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: 0.2s;
  &:hover {
    filter: brightness(1.2);
  }
`;

const CloseButton = styled.button`
  background: #c0392b;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  &:hover {
    background: #e74c3c;
  }
`;

const ImageBody = styled.div`
  flex: 1;
  background: #111;
  overflow: hidden; /* O scroll será controlado pela ScrollArea */
  display: flex;
  justify-content: center;
`;

const ScrollArea = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto; /* Habilita scroll se a imagem for maior que o container */
  padding: 20px;
  display: flex;
  justify-content: center;

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d4af37;
    border-radius: 10px;
  }
`;

const ReceiptImage = styled.img`
  max-width: 100%; /* Garante que não estoure a largura se for pequena */
  /* Se você quiser que ela sempre tenha scroll vertical independente do tamanho, 
     pode remover o max-width ou definir uma largura fixa maior */
  height: auto;
  border-radius: 4px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
`;

const PdfFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;

const Footer = styled.div`
  padding: 10px;
  text-align: center;
  background: #000;
  color: #666;
  border-top: 1px solid #333;
`;
